module.exports = __webpack_public_path__ + "static/media/arrow_drop_down_icon.9d0ec951.svg";